import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentMultiCreatePasskeyData,
  type EnrollmentMultiCreatePasskeySubmitOutput,
} from '../../../../models'

export const getEnrollmentMultiCreatePasskeyDataMock: EnrollmentMultiCreatePasskeyData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/create-passkey`',
  enrollmentData: {
    applicationId: '305802305',
    passkeyPublicKeyCredentialRequestOptions: JSON.stringify({
      rp: { name: 'Evergreen Wealth', id: 'localhost' },
      user: {
        name: 'nick+wh@evergreen.money',
        displayName: 'Nick Navarro',
        id: 'dXNlci0wOTU3YTZjOC1iZmY1LTQ3ZDctYTMwMC05MWI4NjAwNWE4YWQ',
      },
      challenge: '1riMFgLYB9oUt5qtChOAuL-BL9hs_U6myyI5Qov9Mh4',
      pubKeyCredParams: [
        { alg: -7, type: 'public-key' },
        { alg: -8, type: 'public-key' },
        { alg: -35, type: 'public-key' },
        { alg: -36, type: 'public-key' },
        { alg: -257, type: 'public-key' },
        { alg: -258, type: 'public-key' },
        { alg: -259, type: 'public-key' },
      ],
      excludeCredentials: [],
      authenticatorSelection: {
        requireResidentKey: false,
        residentKey: 'preferred',
        userVerification: 'preferred',
      },
      attestation: 'direct',
      extensions: { credProps: true },
    }),
  },
}

export const submitEnrollmentMultiCreatePasskeyDataMock: EnrollmentMultiCreatePasskeySubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/disclosures',
  enrollmentData: {
    passkeyRegistered: true,
  },
}

export const mockGetEnrollmentMultiCreatePasskeyData = graphql.mutation('getEnrollmentMultiCreatePasskeyData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiCreatePasskeyDataMock } })
})

export const mockSubmitEnrollmentMultiCreatePasskeyData = graphql.mutation(
  'submitEnrollmentMultiCreatePasskeyData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiCreatePasskeyDataMock } })
  },
)

export const mockEnrollmentMultiCreatePasskey = [
  mockGetEnrollmentMultiCreatePasskeyData,
  mockSubmitEnrollmentMultiCreatePasskeyData,
]
